export default __webpack_public_path__ + "static/media/Dayo-Amusu.1da720d8.jpg";